import { BrowserRouter, Routes, Route } from 'react-router-dom'
import HomePage from './pages/HomePage'
import AboutUsPage from './pages/AboutUsPage'
import ProductsPage from './pages/ProductsPage'
import ServicesPage from './pages/ServicesPage'
import BlogsPage from './pages/BlogsPage'
import ContactUsPage from './pages/ContactUsPage'
import DubaiLandingPage from './pages/DubaiLandingPage'
import WebDevelopmentPage from './pages/services/WebDevelopmentPage'
import DataAnalyticsPage from './pages/services/DataAnalyticsPage'
import CustomSoftwarePage from './pages/services/CustomSoftwarePage'
import MobileAppPage from './pages/services/MobileAppPage'
import CloudSolutionsPage from './pages/services/CloudSolutionsPage'
import UiUxDesignPage from './pages/services/UiUxDesignPage'
import DevOpsAwsPage from './pages/services/DevOpsAwsPage'
import SitemapPage from './pages/SitemapPage'

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about-us" element={<AboutUsPage />} />
        <Route path="/products" element={<ProductsPage />} />
        <Route path="/services" element={<ServicesPage />} />
        <Route path="/blogs" element={<BlogsPage />} />
        <Route path="/contact-us" element={<ContactUsPage />} />
        <Route path="/software-development-company-dubai" element={<DubaiLandingPage />} />
        <Route path="/services/web-development" element={<WebDevelopmentPage />} />
        <Route path="/services/data-analytics" element={<DataAnalyticsPage />} />
        <Route path="/services/custom-software-development" element={<CustomSoftwarePage />} />
        <Route path="/services/mobile-app-development" element={<MobileAppPage />} />
        <Route path="/services/cloud-solutions" element={<CloudSolutionsPage />} />
        <Route path="/services/ui-ux-design" element={<UiUxDesignPage />} />
        <Route path="/services/devops-aws-services" element={<DevOpsAwsPage />} />
        <Route path="/sitemap" element={<SitemapPage />} />
      </Routes>
    </BrowserRouter>
  )
}

export default App
